<template>
  <div class="container">
    <router-view/>
    <footer class="text-center text-lg-start fixed-bottom">
      <div class="container p-4">
        <div class="row">
          <div class="col text-center">
            <router-link to="/">Mis Links</router-link> |
            <router-link to="/about">T&eacute;rminos y Condiciones</router-link>
          </div>
        </div>
      </div>
      <div class="text-center p-3" style="background-color: rgba(0, 0, 0, 0.2);">
        © 2020 Copyright:
        <a class="text-dark" href="#">landah.com.mx</a>
      </div>
    </footer>
  </div>
</template>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
